import {Box, styled} from "@mui/material";
import ThemedText from "../../../components/text";
import Label from "../../../resources/label";
import Base from "../../../components/base";
import NewOperator from "../../../components/form/new-operator";
import {scale} from "../../../utils";


const Wrapper = styled(Box)({
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: scale(50),
  rowGap: scale(38),
  marginLeft: 'auto',
  marginRight: 'auto',
});

const CreaOperatore = () => {

  //const navigate = useNavigate();
  return (
    <Wrapper>
      <ThemedText
        fontSize={scale(42)}
        align={'center'}
        fontWeight={300}
        lineHeight={scale(52)}
        letterSpacing={scale(0.42)}
        text={Label.ADMIN_CREATE_OPERATOR_DESCRIPTION}
      />
      <Base
        style={{
          width: scale(500),
          height: scale(560),
      }}>
        <NewOperator
          style={{
            marginTop: scale(50),
            marginBottom: scale(58),
            height: '100%',
          }}
        />
      </Base>
    </Wrapper>
  );
};

export default CreaOperatore;
